export const UserDetailLang = {
    firstname: 'نام',
    lastname: 'نام خانوادگی',
    email: 'ایمیل کاربری',
    number: 'شماره همراه',
    language: 'زبان',
    regionTime: 'منطقه زمانی',
    save: 'ذخیره',
    err400: 'تایپ فایل وارد شده اشتباه است. لطفا یک فایل با فرمت jpg، jpeg، png یا gif آپلود کنید.',
    error: 'خطایی رخ داده است، مجددا تلاش کنید',
    wrongPhoneNumber: 'فرمت شماره وارد شده صحیح نیست',
    wrongEmail: 'فرمت ایمیل وارد شده صحیح نیست',
    success: 'اطلاعات شما با موفقیت بروزرسانی شد',
};
